import { useEffect } from 'react';
import styled from 'styled-components';
import { useMouseStore } from '../../hooks/stores/mouseStore';
import { useUIStore } from '../../hooks/stores/uiStore';

export const SidebarResizeHandle = () => {
  const [mouseData] = useMouseStore();
  const [UIData, setUIData] = useUIStore();

  useEffect(() => {
    if (mouseData.isDragging && UIData.isSidebarResizing) {
      setUIData({ sidebarWidth: mouseData.pos.x });
    }
  }, [mouseData.pos, mouseData.isDragging, UIData.isSidebarResizing]);

  useEffect(() => {
    if (!mouseData.isDown) {
      setUIData({ isSidebarResizing: false });
    }
  }, [mouseData.isDown]);

  useEffect(() => {
    if (UIData.isSidebarResizing) {
      setUIData({ cursor: 'col-resize' });
    } else {
      setUIData({ cursor: 'default' });
    }
  }, [UIData.isSidebarResizing]);

  return (
    <ResizeHandle
      $isResizing={UIData.isSidebarResizing}
      onMouseDown={() => {
        setUIData({ isSidebarResizing: true });
      }}
    />
  );
};

const ResizeHandle = styled.div<{ $isResizing: boolean }>`
  cursor: col-resize;
  position: absolute;
  top: 0;
  right: 0;
  box-sizing: border-box;
  width: 4px;
  height: 100%;
  z-index: 1;

  background-color: var(--primary-1);
  opacity: 0;

  transition: opacity 0.3s ease;
  transition-delay: 0.3s;
  &:hover {
    opacity: 0.3;
  }

  ${({ $isResizing }) =>
    $isResizing &&
    `
    opacity: 0.3;
  `}
`;
